'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  wrapInScriptTags: function wrapInScriptTags(scriptId, scriptBody) {
    if (!scriptBody) {
      return '';
    }

    return '\n<script id="' + scriptId + '">\n' + scriptBody + '\n</script>';
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-on-rails/node_package/lib/RenderUtils.js
// module id = 367
// module chunks = 0